import { jsx as _jsx } from "react/jsx-runtime";
import { typographyComponents } from './BKJTypography.styled.js';
export const BKJTypography = ({ variant = 'Body', element = 'span', children, }) => {
    const Component = typographyComponents[element];
    return _jsx(Component, { "$variant": variant, children: children });
};
//# sourceMappingURL=BKJTypography.js.map